import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M11.29 15.29a1.6 1.6 0 0 0-.12.15.76.76 0 0 0-.09.18.64.64 0 0 0-.06.18 1.4 1.4 0 0 0 0 .2.84.84 0 0 0 .08.38.9.9 0 0 0 .54.54.94.94 0 0 0 .76 0 .9.9 0 0 0 .54-.54A1 1 0 0 0 13 16a1 1 0 0 0-.6154-.9289 1 1 0 0 0-1.0946.2189M12 2a10 10 0 1 0 0 20.0001A10 10 0 0 0 12 2m0 18a8.0005 8.0005 0 0 1-7.391-4.9385A8 8 0 1 1 12 20m0-13a3 3 0 0 0-2.6 1.5 1 1 0 1 0 1.73 1A1 1 0 0 1 12 9a1 1 0 1 1 0 2 1 1 0 0 0-1 1v1a1.0001 1.0001 0 0 0 2 0v-.18a3 3 0 0 0 1.9334-3.3281A3 3 0 0 0 12 7"
}), "QuestionCircle", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
